import {createUseStyles} from 'react-jss';
export default createUseStyles({
  boardContainer: {
    display:'flex',
    flexDirection:'column',
    justifyContent:'flex-start'
  },
  boardInfo: {
    padding: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h1': {
      fontSize: 22,
      color: 'rgba(0,0,0,0.7)',
      fontWeight: 'bold',
      marginRight: 20
    },
    '& button': {
      height: 30,
      width: 'auto',
      borderRadius: '5px',
      marginTop: 0,
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      padding: '0 5px',
      '& svg': {
        fontSize: 20,
        marginRight: 5
      }
    }
  },
  rightSide: {
    display: 'flex',
    alignItems: 'center'
  },
  users: {
    display: 'flex',
    marginRight: 20,
    alignItems:'center',
    color: 'rgba(0,0,0,0.5)',
    fontWeight: 'bold',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  userInfo: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    overflow: 'hidden',
    boxShadow: '0 3px 6px rgba(0,0,0,0.5)',
    '&:not(:last-child)': {
      marginRight: -25
    },
    '&:last-child': {
      marginRight: 10
    },
    '& img': {
      minWidth: '100%',
      height: '100%'
    }
  }
})
